import React, { useContext, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Stepper from "@material-ui/core/Stepper";
import Typography from "@material-ui/core/Typography";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepConnector from "@material-ui/core/StepConnector";
import getForm from "./GetForm";
import { QontoStepIcon } from "../../utils/utils";
import { routes } from './StepperConfig/routes';
import {
  StepperContext,
  EWContext
} from "../../context/EWContext";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: "#FFFFFF",
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

export default function EWStepper() {
  const classes = useStyles();
  const [savingState, setSavingState] = useState(true);
  const [stepperState, setStepperState] = useContext(StepperContext);
  const [accountState, setAccountState] = useContext(EWContext);

  const activeStep = stepperState.activeStep;
  const steps = stepperState.steps;

  const {
    groups,
    appReference,
    eligibilityError,
    closeEligibilityCallback,
    eligibilityAnswersCallback
  } = accountState;

  const module = appReference ? routes[appReference] : routes['default'];

  const getStepContent = (activeStep, handleNext, handleBack) => {
    const groupsWithComponent = groups.map((group) => {
      if(group.label.toString().toLowerCase().includes("account")) {
        group.instructions  = accountState.headerMessage ||"";
      }
      
      group.extraInfoAfterRequired = accountState.contentMessage || "";

      group.component = getForm(group, handleNext, handleBack);
      return group;
    });

    return groupsWithComponent.find((group) => group?.id === activeStep.id)?.component || null;
  };

  const isStepFailed = (step) => eligibilityError.error && step === activeStep.index;

  const handleNext = () => {
    if (activeStep.index === steps.length - 1) {
      const eligibilityResponse = module.handleEWCompleted(accountState);
      if (eligibilityAnswersCallback && window[eligibilityAnswersCallback]) {
        setSavingState(true);
        window[eligibilityAnswersCallback](eligibilityResponse);
        handleReset();
      } else {
        setSavingState(false);
      }
      return;
    }
    module.handleNextCallback();
    setStepperState((prevStepperState) => {
      const index = prevStepperState.activeStep.index + 1;
      const newActiveStep = {
        index,
        id: groups[index]?.id || "",
        label: groups[index]?.label || "",
      };
      return {
        ...prevStepperState,
        activeStep: newActiveStep,
      };
    });
  };

  const handleBack = () => {
    if (activeStep.index === 0) {
      handleReset();
      module.handleFirstBackButton(accountState, setAccountState);
      if (closeEligibilityCallback && window[closeEligibilityCallback]) window[closeEligibilityCallback]();
      return;
    }
    module.handleBackCallback();
    setStepperState((prevStepperState) => {
      const index = prevStepperState.activeStep.index - 1;
      const newActiveStep = {
        index,
        id: groups[index]?.id || "",
        label: groups[index]?.label || "",
      };
      return {
        ...prevStepperState,
        activeStep: newActiveStep,
      };
    });
  };

  const handleReset = () => {
    setStepperState((prevStepperState) => {
      const index = 0;
      const newActiveStep = {
        index,
        id: groups[index]?.id || "",
        label: groups[index]?.label || "",
      };
      return {
        ...prevStepperState,
        activeStep: newActiveStep,
      };
    });
  };

  return (
    <Grid className={classes.root}>
      <Stepper
        alternativeLabel
        activeStep={activeStep.index}
        connector={<StepConnector />}
      >
        {steps.map((label, index) => {
          let error = false;
          if (isStepFailed(index)) {
            error = true;
          }
          return (
            <Step key={label}>
              {error ? (
                <StepLabel StepIconComponent={QontoStepIcon}>
                  {label}
                </StepLabel>
              ) : (
                <StepLabel>{label}</StepLabel>
              )}
            </Step>
          );
        })}
      </Stepper>
      <div>
        {savingState ? ( getStepContent(activeStep, handleNext, handleBack) ) : 
        (
          <Typography variant="h4" gutterBottom>
            Error: Saving information. Try Again.
          </Typography>
        )}
      </div>
    </Grid>
  );
}
